/**
 * @file: SaveButton.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The primary CTA, mirroring the lead-detail filled brand button (lifted
 * shadow, rpx(52) tall, bold white label).
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CalendarPlus } from 'lucide-react-native';
import { TouchableOpacity } from 'react-native';

export const SaveButton = ({ onPress }: { onPress: () => void }) => {
  const { rpx } = useResponsiveContext();
  return (
    <TouchableOpacity
      activeOpacity={0.85}
      onPress={onPress}
      style={{
        flexDirection: 'row',
        height: rpx(52),
        borderRadius: rpx(13),
        marginTop: rpx(28),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: LD.brand,
        shadowColor: LD.brand,
        shadowOpacity: 0.22,
        shadowRadius: rpx(10),
        shadowOffset: { width: 0, height: rpx(3) },
        elevation: 2,
      }}
    >
      <CalendarPlus
        size={rpx(18)}
        color="#fff"
        style={{ marginRight: rpx(7) }}
      />
      <Typography.Text size={rpx(15)} color="#fff" bold>
        创建预约
      </Typography.Text>
    </TouchableOpacity>
  );
};
